import { Controller } from 'react-hook-form';
import OpeningQuote from 'assets/icons/icon-quote-opening.svg';
import ClosingQuote from 'assets/icons/icon-quote-closing.svg';
import TextareaAutosize from 'react-textarea-autosize';
import { useMemoFormContext } from '../context/FormContext';
import TitleField from '../fields/TitleField';
import SourceField from '../fields/SourceField';
import { MemoType } from 'models/Memo';
import { requireContentForType } from '../utils/validators';
import { useTranslations } from 'next-intl';

const QuoteForm: React.FC = () => {
  const t = useTranslations();
  const {
    control,
    isTitleVisible,
    isSourceVisible,
    isFullyExpanded,
    getValues,
  } = useMemoFormContext();

  return (
    <div>
      {isTitleVisible && <TitleField />}

      <OpeningQuote
        className={styles.top.openingQuote}
        width={28}
        height={28}
      />

      <Controller
        control={control}
        name="content"
        render={({ field: { onChange, value, onBlur } }) => (
          <TextareaAutosize
            id={'content'}
            minRows={1}
            maxRows={isFullyExpanded === false ? 6 : undefined}
            name={'content'}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            className="block w-full bg-transparent border-0 py-0 px-0 text-sm resize-none placeholder-ink-tertiary focus:ring-0"
            placeholder={t('memoComposer.quote.placeholder')}
          />
        )}
        rules={{
          validate: requireContentForType(
            getValues,
            MemoType.Quote,
            t('memoComposer.contentRequired'),
          ),
        }}
      />

      <div className={styles.bottom.container}>
        <div className={styles.bottom.author.container}>
          <hr className={styles.bottom.author.hyphen} />

          <Controller
            control={control}
            name="author"
            render={({ field: { onChange, value, onBlur } }) => (
              <input
                autoComplete="off"
                className={styles.bottom.author.input}
                value={value || ''}
                onChange={onChange}
                onBlur={onBlur}
                placeholder={t('memoComposer.quote.author')}
              />
            )}
          />
        </div>
        <ClosingQuote
          className={styles.bottom.closingQuote}
          width={28}
          height={28}
        />
      </div>

      {isSourceVisible && <SourceField />}
    </div>
  );
};

export default QuoteForm;

const styles = {
  top: {
    openingQuote: 'relative mt-2 text-accent-ink',
  },
  bottom: {
    container: 'flex items-center justify-center',
    author: {
      hyphen: 'w-5 border-stroke',
      container:
        'flex flex-1 items-center mt-4 flex-1 text-sm text-ink-primary',
      input:
        'w-full bg-transparent border-none outline-hidden focus:outline-hidden focus:border-transparent focus:ring-0',
    },
    closingQuote: 'text-accent-ink ml-auto',
  },
};
